export const blockIconsCommunicationNotificationsNew = (
	<span className='material-symbols-outlined'>notifications</span>
);
